export default "__VITE_ASSET__D$nkIAXx__"